import { useFilterConditionAtom } from '@/features/analyze/atoms/filterCondition.atom';
import { DateRangePicker } from '@/features/analyze/components/Filter/DateRangePicker';
import { MIN_PUBLISHED_AT } from '@/features/analyze/constants';
import { rwColors } from '@/styles/colors';
import {
  CubeIcon,
  GlobeAltIcon,
  HashtagIcon,
  TagIcon,
} from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { SelectedNodesList } from '@/features/connect-dots/components//filter/SelectedNodesList';
import { FilterResetButton } from '@/features/connect-dots/components//filter/FilterResetButton';
import { FilterButtons } from '@/features/connect-dots/components/filter/FilterButtons';
import { getCurrentLanguage } from '@/lib/i18n/getCurrentLanguage';

import clsx from 'clsx';

interface FilterMirrorContainerProps {
  onClose: () => void;
}

export const FilterMirrorContainer = ({
  onClose,
}: FilterMirrorContainerProps) => {
  const [filterCondition] = useFilterConditionAtom();
  const { t } = useTranslation();

  return (
    <div
      className="flex w-[280px] flex-col bg-white"
      style={{ height: 'calc(100vh - 88px)' }}
    >
      {/* タイトル部分（固定） */}
      <div className="shrink-0 bg-rw-light-gray/50 p-2">
        <div className="">
          <div
            className="text-xl font-medium"
            style={{ color: rwColors['dark-gray'] }}
          >
            <span className="m-4">Filter</span>
          </div>
          <FilterButtons onClose={onClose} />
        </div>
        <hr className="my-0.5 h-[3px] bg-rw-dark-gray/10" />
      </div>

      {/* スクロール可能なコンテンツエリア */}
      <div className={clsx('flex-1 overflow-y-auto bg-rw-light-gray/50 px-2')}>
        <div className="flex flex-col">
          <div className="relative p-2 text-rw-dark-gray/80">
            <DateRangePicker
              label={t('公開日時')}
              locale={getCurrentLanguage()}
              note={t('2019年以降の記事のみ収録されています。')}
              selectedStart={filterCondition.publishedStartAt}
              selectedEnd={filterCondition.publishedEndAt}
              minDate={MIN_PUBLISHED_AT}
              onStartChange={() => {}}
              onEndChange={() => {}}
            />
            <div
              className="absolute inset-0 z-10 cursor-not-allowed bg-rw-light-gray/20"
              style={{ pointerEvents: 'auto' }}
            />
          </div>
          <SelectedNodesList
            facetKey="themes"
            modes={['and', 'or']}
            label={t('テーマ')}
            labelColor={rwColors.sub}
            IconComponent={HashtagIcon}
            labelClassName="text-rw-sub"
          />

          <div className="relative">
            <SelectedNodesList
              label={t('国グループ')}
              modes={['or']}
              labelColor={rwColors['light-gray']}
              backgroundColor={rwColors['dark-gray']}
              facetKey="countryTags"
              labelClassName="text-rw-dark-gray/100"
            />

            <SelectedNodesList
              label={t('国・地域')}
              modes={['or', 'not']}
              labelColor={rwColors.green}
              facetKey="countries"
              IconComponent={GlobeAltIcon}
              labelClassName="text-rw-green/50"
            />

            <SelectedNodesList
              label={t('組織タイプ')}
              modes={['or']}
              labelColor={rwColors.green}
              facetKey="organizationTypes"
              IconComponent={CubeIcon}
              labelClassName="text-rw-green/50"
            />
            <div
              className="absolute inset-0 z-10 cursor-not-allowed bg-rw-light-gray/60"
              style={{ pointerEvents: 'auto' }}
            />
          </div>

          <SelectedNodesList
            label={t('タグ')}
            modes={['and', 'or', 'not']}
            labelColor={rwColors.black}
            facetKey="topicTags"
            IconComponent={TagIcon}
            labelClassName="text-rw-black"
          />
        </div>
      </div>

      {/* 固定フッター */}
      <div className="shrink-0 bg-rw-light-gray/50 p-2">
        <FilterResetButton />
      </div>
    </div>
  );
};
